class Authorization {
    constructor() {
        
    }


    shouldFilterDataByUser (role, module_name, email) {
        if(module_name == 'client' && role!='admin') {
            return true;
        }
        else if (module_name == 'product_posting') {
            if(role==='sale') {
                return true;
            }
        }
        else if (module_name == 'product_posting_v3'){
            return false;
        }
        else if (module_name == 'product') {
            // For product module, only filter by user if role is ctv
            if(role==='ctv') {
                return true;
            }
            return false;
        }
        else {
            // if this user is ctv, we will show data created by them only
            if(role==='ctv') {
                return true;
            }
        }

        return false;
    }
  }
  
  
export default Authorization;